import { Activity, GROUP_SHOW_TYPE, GraphStyle } from 'components/planner/types';
import Konva from 'konva';
import { KonvaEventObject } from 'konva/lib/Node';
import { Group } from 'react-konva';
import { DateNumber } from 'types/global';
import { isActivityVisible } from '../../utils';
import ActivityCmp from './ActivityCmp';
import ActivityCompact from './ActivityCompact';
import DataItem from './DataItem';



/**
 * Visualizzazione dei dati di un GROUP
 * complreso il BG 
 */
function Activities({
	start,
	activities,
	showType,
	activityHighlight,
	activitySelect,
	onActivityEnter,
	onActivityLeave,
	onActivityClick,
	onActivityDoubleClick,
	style,
	...props
}: ActivitiesProps) {

	// RENDER
	if (!activities) return null

	return (
		<Group {...props}>
			{activities.map ((activity, index) => {
				if (!isActivityVisible(activity, start, style.columns)) return null
				const isDisabled = activitySelect && !activitySelect.includes(activity)
				const isHighlight = activityHighlight?.includes(activity)

				if (showType != GROUP_SHOW_TYPE.COMPACT) {
					return activity.length ? (
						<ActivityCmp key={index}
							start={start}
							activity={activity}
							highlight={isHighlight}
							disabled={isDisabled}
							onCellEnter={e => onActivityEnter(e, activity)}
							onCellLeave={e => onActivityLeave(e, activity)}
							onCellClick={e => onActivityClick(e, activity)}
							onCellDoubleClick={e => onActivityDoubleClick(e, activity)}
							style={style}
						/>
					) : (
						<DataItem key={index}
							start={start}
							activity={activity}
							highlight={isHighlight}
							disabled={isDisabled}
							onCellEnter={e => onActivityEnter(e, activity)}
							onCellLeave={e => onActivityLeave(e, activity)}
							style={style}
						/>
					)
				} else {
					return <ActivityCompact key={index}
						start={start}
						activity={activity}
						highlight={isHighlight}
						disabled={isDisabled}
						onCellEnter={e => onActivityEnter(e, activity)}
						onCellLeave={e => onActivityLeave(e, activity)}
						onCellClick={e => onActivityClick(e, activity)}
						onCellDoubleClick={e => onActivityDoubleClick(e, activity)}
						style={style}
					/>
				}
			})}

			
		</Group>
	)
}

export default Activities


type ActivitiesProps = {
	/** data margina sinistro */
	start: DateNumber,
	/** tutte le ACTIVITY da visualizzare */
	activities: Activity[],
	/** indica se la visualizzazione è di titpo "compact" o no */
	showType: GROUP_SHOW_TYPE,
	/** activities in hightlight */
	activityHighlight: Activity[],
	/** activities selezionate */
	activitySelect: Activity[],

	onActivityEnter: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityLeave: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityClick: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityDoubleClick: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,

	style: GraphStyle,
} & Konva.NodeConfig

